import React, { useContext, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import SignupProgress from "../../../Components/SignupProgress";
import HeightModal from "../../../modals/HeightModal";
import WeightModal from "../../../modals/WeightModal";
import { images } from "../../../Assets/images";
import { Link } from "react-router-dom";

const CreateAccount4 = () => {
  const {
    signupData,
    updateSignupData,
    createAccountScreenTwo,
    translatedLabels,
    logoUrl,
    is4Life,
  } = useContext(GlobalContext);
  const authLabel = translatedLabels?.auth;
  const [showWeightModal, setWeightModal] = useState(false);
  const [showHeightModal, setShowHeightModal] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    createAccountScreenTwo();
  };

  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const updateUserData = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const foodItems = [
    {
      label: "Fruit",
      name: "fruits",
      image: images.fruit,
    },
    {
      label: "Veggie",
      name: "vegetables",
      image: images.vegetable,
    },
    {
      label: "Grains",
      name: "wholeGrains",
      image: images.wholeGrain,
    },
    {
      label: "Dairy",
      name: "dairy",
      image: images.dairy,
    },
    {
      label: "Sugars",
      name: "sugar",
      image: images.sugar,
    },
    {
      label: "Red Meat",
      name: "redMeat",
      image: images.redMeat,
    },
    {
      label: "Fish",
      name: "fish",
      image: images.fish,
    },
  ];

  return (
    <>
      <section id="createAccountPage" className="login-section-bg">
        <div className="container-main">
          <div className="d-flex justify-content-center">
            <div className="app-logo">
              <img
                src={logoUrl || images.appLogo}
                alt="app-logo"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = images.appLogo;
                }}
              />
            </div>
          </div>
          <div className="content-card">
            <SignupProgress currentStep={is4Life ? 4 : 3} />
            <h3 className="mb-4 text-center">
              {authLabel?.create_new_account?.label_value ||
                "Create new account"}
            </h3>
            <h5 className="survey-heading mb-0">
              How many times per week do you spend at least 30 minutes doing the
              following types of activity?
            </h5>

            <form className="login-form pt-0" onSubmit={handleSubmit}>
              <div className="row my-3">
                {[
                  {
                    label: "Light Activity",
                    desc: "(Minimal exertion, can talk easily or even sing)",
                    name: "lightActivity",
                    image: images.lightActivity,
                  },
                  {
                    label: "Moderate Activity",
                    desc: "(Heavier breathing, can talk with some effort, little to moderate sweating)",
                    name: "moderateActivity",
                    image: images.moderateActivity,
                  },
                  {
                    label: "Intense Activity",
                    desc: "(Labored breathing, difficult to talk, heavy sweating)",
                    name: "intenseActivity",
                    image: images.intenseActivity,
                  },
                ].map((item) => (
                  <div className="col-md-4 mt-3" key={item.name}>
                    <div className="input-image">
                      <img
                        src={item.image}
                        alt={item.label}
                        className="activity-icon"
                      />
                    </div>

                    <label className="form-label mb-0 fw-semibold">
                      {item.label}
                    </label>
                    <p className="mb-0 small text-muted">{item.desc}</p>

                    {[
                      "I don't do this kind of activity",
                      "1–2 times",
                      "3–4 times",
                      "5+ times",
                    ].map((option, index) => (
                      <div
                        className="form-check text-start ps-0 mt-2"
                        key={index}
                      >
                        <div className="custom-checkbox form-check p-0">
                          <input
                            id={`${item.name}-${index}`}
                            type="radio"
                            value={option}
                            name={item.name}
                            onChange={handleChange}
                            checked={formData[item.name] === option}
                          />
                          <label
                            className="custom-label"
                            htmlFor={`${item.name}-${index}`}
                          >
                            {option}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>

              <div className="mt-4 text-center">
                <Link to={"/create-account-5"} className="btn btn-primary">
                  {authLabel?.next?.label_value || "Next"}
                </Link>
              </div>
            </form>
          </div>
        </div>
      </section>
      <WeightModal
        show={showWeightModal}
        onClose={() => setWeightModal(false)}
        initialWeight={signupData.weight}
        initialUnit={signupData.weightUnit}
        onSave={({ weight, weightUnit }) => {
          if (weightUnit === "kg") {
            if (weight < 20 || weight > 300) {
              window.showToast("error", "Weight must be between 20–300 kg.");
              return;
            }
          } else if (weightUnit === "lbs") {
            if (weight < 44 || weight > 661) {
              window.showToast("error", "Weight must be between 44–661 lbs.");
              return;
            }
          }
          updateSignupData("weight", weight);
          updateSignupData("weightUnit", weightUnit);
          setWeightModal(false);
        }}
      />
      <HeightModal
        show={showHeightModal}
        onClose={() => setShowHeightModal(false)}
        initialHeight={signupData.height}
        initialUnit={signupData.heightUnit}
        onSave={({ height, heightUnit }) => {
          if (heightUnit === "cm") {
            if (height < 100 || height > 250) {
              window.showToast("error", "Height must be between 100–250 cm.");
              return;
            }
          } else if (heightUnit === "feet") {
            if (height < 3.3 || height > 8.2) {
              window.showToast("error", "Height must be between 3.3–8.2 feet.");
              return;
            }
          }
          updateSignupData("height", height);
          updateSignupData("heightUnit", heightUnit);
          setShowHeightModal(false);
        }}
      />
    </>
  );
};

export default CreateAccount4;
